import { RefObject } from "react";

// Utility to scroll to invalid form basic input / custom component
const scrollToErrorField = (
  ref: RefObject<HTMLFormElement>,
  errorElements: string[]
) => {
  const firstFieldName: string = errorElements[0];
  const currentFormRef: any = ref?.current;
  const inputs: HTMLElement[] = Object.values(currentFormRef);
  /**
   *  Error fields can be either basic or custom component,
   * so if the basic input id is missing - crawl through DOM
   */
  const errorField: HTMLElement | null =
    inputs.find((el) => el?.id === firstFieldName) ??
    document.getElementById(firstFieldName);
  errorField?.scrollIntoView({
    behavior: "smooth",
    block: "center",
    inline: "center",
  });
};

export default scrollToErrorField;
